import React from 'react';
import ButtonsGeneric from '../../../../../../../../components/NovoSistema/ButtonsGeneric';
import { ContainerSection } from '../../../../../../../../components/NovoSistema/ContainerSection';
import InputText from '../../../../../../../../components/NovoSistema/InputText';
import SelectAndOptions from '../../../../../../../../components/NovoSistema/SelectAndOptions';
import { WrapperInputsNewSystem } from '../../../../../../../../components/NovoSistema/WrapperInputsNewSystem';

export default function MotivoDeAjusteAdd({ setOption }) {
  return (
    <div>
      <ContainerSection>
        <div>
          <WrapperInputsNewSystem>
            <InputText title="Código" id="Codigo" widthPercentage="45%" disabled={true} />
            <SelectAndOptions
              title="* Tipo de Ajuste"
              id="TipoDeAjuste"
              optionsArray={['', 'Entrada', 'Saída', 'Transferência']}
              widthPercentage="45%"
            />
          </WrapperInputsNewSystem>
          <WrapperInputsNewSystem>
            <InputText title="* Descrição" id="Descricao" widthPercentage="100%" />
          </WrapperInputsNewSystem>
        </div>
      </ContainerSection>
      <ButtonsGeneric>
        <button className="success">Salvar</button>
        <button className="error" onClick={() => setOption('search')}>
          Retornar
        </button>
      </ButtonsGeneric>
      <span> {' * '} Campo de preenchimento Obrigatório</span>
    </div>
  );
}
